export const initialValues = {
  analyseName: '',
  projectName: '',
  newProjectName: '',
  projectType:'placeme.save_analyse.private',
}
